import PropTypes from "prop-types";
import React from "react";

export const PlaybackRateContext = React.createContext({
  playbackRate: 1,
});

export const PlaybackRateProvider = ({
  children,
  playbackRate: defaultPlaybackRate = 1,
  ...props
}) => {
  const [playbackRate, setPlaybackRate] = React.useState(defaultPlaybackRate);

  const value = React.useMemo(
    () => ({ playbackRate, setPlaybackRate }),
    [playbackRate],
  );

  // This is super hacky but I can't think of any other way to do this.
  if (window.VersePlayer) {
    window.VersePlayer.setPlaybackRate = setPlaybackRate;
  }

  return (
    <PlaybackRateContext.Provider {...props} value={value}>
      {children}
    </PlaybackRateContext.Provider>
  );
};

PlaybackRateProvider.propTypes = {
  children: PropTypes.node,
  playbackRate: PropTypes.number,
};

export function usePlaybackRate() {
  const { playbackRate, setPlaybackRate } =
    React.useContext(PlaybackRateContext);

  return React.useMemo(
    () => [playbackRate, setPlaybackRate],
    [playbackRate, setPlaybackRate],
  );
}

export const WithPlaybackRate = ({ children }) => {
  const [playbackRate, setPlaybackRate] = usePlaybackRate();

  return children({ playbackRate, setPlaybackRate });
};

WithPlaybackRate.propTypes = {
  children: PropTypes.func.isRequired,
};
